@if (inputType === 'header') {
  <!-- DESKTOP HEADER SEARCH -->
  <button
    nz-button
    nzType="text"
    class="hidden lg:flex search-box cursor-pointer items-center relative"
    [ngClass]="{ active: !!searchQueryControl?.value || searchInFocus }"
  >
    <form [formGroup]="searchForm" class="m-0 lg:mr-2">
      <input
        class="search-input hidden lg:block font-light text-base lg:text-lg"
        type="text"
        name=""
        placeholder="{{ 'common.search' | translate }}"
        formControlName="query"
        (focus)="searchInFocus = true"
        (blur)="onSearchInputBlur()"
      />
    </form>
    <svg class="w-6 h-6 lg:w-8 lg:h-8" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 13.8333C6 9.78324 9.28324 6.5 13.3333 6.5C17.3835 6.5 20.6667 9.78324 20.6667 13.8333C20.6667 17.8835 17.3835 21.1667 13.3333 21.1667C9.28324 21.1667 6 17.8835 6 13.8333ZM13.3333 4.5C8.17868 4.5 4 8.67868 4 13.8333C4 18.988 8.17868 23.1667 13.3333 23.1667C15.5504 23.1667 17.5869 22.3936 19.1881 21.1024L26.2929 28.2071C26.6835 28.5976 27.3165 28.5976 27.7071 28.2071C28.0976 27.8165 28.0976 27.1835 27.7071 26.7929L20.6024 19.6881C21.8936 18.0869 22.6667 16.0504 22.6667 13.8333C22.6667 8.67868 18.488 4.5 13.3333 4.5Z"
        fill="#222528"
      />
    </svg>
    <ng-container *ngTemplateOutlet="resultsScrollbar"></ng-container>
  </button>
  <!-- MOBILE HEADER SEARCH -->
  <button
    class="flex lg:hidden flex-row items-center mobile-search-box rounded-lg right-0 top-5 z-10"
    [ngClass]="{ active: searchInFocus }"
  >
    <button
      nz-button
      nzType="text"
      class="h-6 w-6 flex flex-row justify-center items-center mobile-search-box-button"
      (click)="onMobileSearchButtonClick()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M4.58203 8.33333C4.58203 5.80202 6.63406 3.75 9.16536 3.75C11.6967 3.75 13.7487 5.80202 13.7487 8.33333C13.7487 10.8647 11.6967 12.9167 9.16536 12.9167C6.63406 12.9167 4.58203 10.8647 4.58203 8.33333ZM9.16536 2.5C5.94371 2.5 3.33203 5.11168 3.33203 8.33333C3.33203 11.555 5.94371 14.1667 9.16536 14.1667C10.551 14.1667 11.8239 13.6835 12.8246 12.8765L17.2651 17.3169C17.5092 17.561 17.9049 17.561 18.1489 17.3169C18.393 17.0728 18.393 16.6772 18.1489 16.4331L13.7085 11.9926C14.5155 10.9918 14.9987 9.719 14.9987 8.33333C14.9987 5.11168 12.387 2.5 9.16536 2.5Z"
          fill="#2C3035"
        />
      </svg>
    </button>
    <form [formGroup]="searchForm" class="flex-1 h-8">
      <input
        class="search-input font-light text-base w-full h-full"
        type="text"
        name=""
        placeholder="{{ 'common.search' | translate }}"
        formControlName="query"
        (focus)="searchInFocus = true"
        (blur)="onSearchInputBlur()"
        #mobileSearchInput
      />
      <!--@if (inputType === 'faq') {
      <korviu-input
        label="{{ 'common.search' | translate }}"
        [control]="searchQueryControl"
        [prefixIconType]="'search'"
        [applyCustomStyle]="true"
      ></korviu-input>
      }-->
    </form>
    <ng-container *ngTemplateOutlet="mobileResultsScrollbar"></ng-container>
  </button>
} @else {
  <div class="relative search-box">
    <korviu-input
      label="{{ 'common.search' | translate }}"
      [control]="searchQueryControl"
      [prefixIconType]="'search'"
      [applyCustomStyle]="true"
      [suffixIconType]="'close'"
      (onFocus)="searchInFocus = true"
      (onBlur)="onSearchInputBlur()"
      (onSuffixClick)="clearSearch()"
    ></korviu-input>
    <div class="hidden lg:block">
      <ng-container *ngTemplateOutlet="resultsScrollbar"></ng-container>
    </div>
    <div class="block lg:hidden">
      <ng-container *ngTemplateOutlet="mobileResultsScrollbar"></ng-container>
    </div>
  </div>
}

<ng-template #resultsScrollbar>
  @if (searchInFocus && (searchResultsIsLoading || searchResultsWasLoaded) && !!searchQueryControl?.value) {
    <div
      class="search-dropdown absolute h-fit rounded-lg p-1 gap-1"
      [class.header]="inputType === 'header'"
      [class.right-10]="inputType === 'header'"
      [class.min-w-64]="inputType === 'header'"
      [class.w-full]="inputType === 'faq'"
    >
      @if (!searchResultsIsLoading) {
        @if (!!searchResultsWasLoaded) {
          @if (!!searchResults?.length) {
            <korviu-scrollbar (reachedBottom)="onScrollReachedBottom()">
              @for (searchResult of searchResults; track searchResult) {
                <div
                  class="search-dropdown-item px-3 py-2 text-left text-base lg:text-lg rounded-lg"
                  (click)="onSearchResultClick(searchResult)"
                >
                  @if (searchResult?.type === SearchResultTypes.FAQ || inputType === 'faq') {
                    <div class="flex flex-row">
                      <span class="flex">{{ getSearchResultAsAny(searchResult)?.question }}</span>
                      <span class="flex mx-1">-</span>
                      <span
                        class="answer"
                        [innerHTML]="
                          getSearchResultAsAny(searchResult)?.answer
                            | truncateBefore: lastQuery : 20
                            | highlight: lastQuery
                        "
                      ></span>
                    </div>
                  }
                  @if (!(searchResult?.type === SearchResultTypes.FAQ || inputType === 'faq')) {
                    <span>{{ getSearchResultText(searchResult) }}</span>
                  }
                </div>
              }
              @if (loadMoreIsLoading) {
                <div class="flex items-center gap-2 font-light px-3 py-2 text-left text-base lg:text-lg rounded-lg">
                  <nz-spin nzSimple></nz-spin>
                  <span>{{ 'common.loading' | translate }}</span>
                </div>
              }
            </korviu-scrollbar>
          } @else {
            <div class="flex items-center gap-2 font-light px-3 py-2 text-left text-base lg:text-lg rounded-lg">
              <span>{{ 'common.noMatchingResults' | translate }}</span>
            </div>
          }
        }
      } @else {
        <div class="flex items-center gap-2 font-light px-3 py-2 text-left text-base lg:text-lg rounded-lg">
          <nz-spin nzSimple></nz-spin>
          <span>{{ 'common.loading' | translate }}</span>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #mobileResultsScrollbar>
  @if (searchInFocus && (searchResultsIsLoading || searchResultsWasLoaded) && !!searchQueryControl?.value) {
    <div
      class="search-dropdown absolute h-fit rounded-lg p-1 gap-1"
      [class.w-100]="inputType === 'header'"
      [class.w-full]="inputType === 'faq'"
    >
      @if (!searchResultsIsLoading) {
        @if (!!searchResultsWasLoaded) {
          @if (!!searchResults?.length) {
            <korviu-scrollbar (reachedBottom)="onScrollReachedBottom()">
              @for (searchResult of searchResults; track searchResult) {
                <div
                  class="search-dropdown-item px-3 py-2 text-left text-base lg:text-lg rounded-lg"
                  (click)="onSearchResultClick(searchResult)"
                >
                  <span>{{ getSearchResultText(searchResult) }}</span>
                </div>
              }
              @if (loadMoreIsLoading) {
                <div class="flex items-center gap-2 font-light px-3 py-2 text-left text-base lg:text-lg rounded-lg">
                  <nz-spin nzSimple></nz-spin>
                  <span>{{ 'common.loading' | translate }}</span>
                </div>
              }
            </korviu-scrollbar>
          } @else {
            <div class="flex items-center gap-2 font-light px-3 py-2 text-left text-base lg:text-lg rounded-lg">
              <span>{{ 'common.noMatchingResults' | translate }}</span>
            </div>
          }
        }
      } @else {
        <div class="flex items-center gap-2 font-light px-3 py-2 text-left text-base lg:text-lg rounded-lg">
          <nz-spin nzSimple></nz-spin>
          <span>{{ 'common.loading' | translate }}</span>
        </div>
      }
    </div>
  }
</ng-template>
